import EditProgramAssistant from './EditProgramAssistant';

export default EditProgramAssistant;
